// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/sample-design/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const sampleDesignEN: PageEntry = {
  id: "post.musterdesign",
  locale: "en",
  slug: "sample-design",
  seo: {
    title: "Glossary: Sample design explained simply | Dietz GmbH",
    description: "Sample design refers to the process of designing and planning samples that serve as templates for production. In the context of products, psample designs can include textile patter",
  },
  type: "post",
  h1: "Glossary: Sample design explained simply",
  intro: "Sample design refers to the process of designing and planning samples that serve as templates for production. In the context of products, psample designs can include textile patterns, graphic designs or even physical models. Effective sample design is critical to making the final product visually appealing, functional and meeting specific requirements. Designers often use specialised software tools and creative processes to design samples that serve as the basis for sample development and creation.",
  blocks: [

  ],
};
